// Premium Backlink Services — design tokens (Indigo/Violet, high-contrast, no dark mode)
export const C = {
  primary:       '#6D28D9',   // Deep Violet
  primaryHover:  '#5B21B6',
  primaryLight:  '#F5F3FF',
  secondary:     '#2563EB',   // Royal Blue (matches logo)
  success:       '#059669',   // Emerald
  successLight:  '#ECFDF5',
  warning:       '#D97706',   // Amber
  warningLight:  '#FFFBEB',
  border:        '#E5E1F5',
  borderLight:   '#F4F2FB',
  bgPage:        '#FFFFFF',
  bgSection:     '#FAF8FE',
  bgCard:        '#FFFFFF',
  textPrimary:   '#170B33',   // Deep ink-violet
  textSecondary: '#4B4165',
  textMuted:     '#7C7295',
  gradient:      'linear-gradient(135deg, #6D28D9 0%, #4C1D95 100%)',
  gradientSoft:  'linear-gradient(135deg, #F5F3FF 0%, #EDE9FE 100%)',
};

export const Section = ({ children, sx = {}, id }) => {
  const { Box } = require('@mui/material');
  return (
    <Box id={id} component="section" sx={{ py: { xs: 7, md: 11 }, ...sx }}>
      {children}
    </Box>
  );
};

export const SectionLabel = ({ children }) => {
  const { Typography } = require('@mui/material');
  return (
    <Typography sx={{
      display: 'inline-block',
      fontSize: '0.72rem',
      fontWeight: 800,
      letterSpacing: '0.15em',
      textTransform: 'uppercase',
      color: C.primary,
      mb: 1.5,
    }}>
      {children}
    </Typography>
  );
};
